import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { useApp } from "../context/AppContext";
import Logo from "../components/Logo";
import SocialAuthButtons from "../components/SocialAuthButtons";
import { LOGO_AUTH_DEFAULT } from "../config/logoSizes";
const EyeIcon = ({ open }) => open ? <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
    <line x1="1" y1="1" x2="23" y2="23" />
  </svg> : <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
    <circle cx="12" cy="12" r="3" />
  </svg>;
const SignIn = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useApp();
  const [form, setForm] = useState({ email: "", password: "" });
  const [showPw, setShowPw] = useState(false);
  const [errors, setErrors] = useState({});
  const [alert, setAlert] = useState(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    localStorage.setItem("taweelai_theme", "light");
    document.documentElement.setAttribute("data-theme", "light");
    document.documentElement.style.colorScheme = "light";
  }, []);
  useEffect(() => {
    if (location.state?.successMsg) setAlert({ type: "success", msg: location.state.successMsg });
    const p = new URLSearchParams(location.search);
    if (p.get("error")) setAlert({ type: "error", msg: t("oauthFailed") });
  }, [location, t]);
  const validate = () => {
    const e = {};
    if (!form.email) e.email = t("emailRequired");
    if (!form.password) e.password = t("passwordRequired");
    return e;
  };
  const handleSubmit = async (ev) => {
    ev.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length) {
      setErrors(errs);
      return;
    }
    setErrors({});
    setLoading(true);
    try {
      const res = await axios.post("/api/auth/signin", form);
      if (res.data?.token) localStorage.setItem("auth_token", res.data.token);
      login(res.data.user);
      // Admins sign in through the normal route and go straight to the dashboard.
      if (res.data.user?.role === "admin") {
        navigate("/admin/dashboard");
        return;
      }
      const isNewUser = sessionStorage.getItem("taweel_show_welcome") === "1";
      sessionStorage.removeItem("taweel_show_welcome");
      navigate(isNewUser ? "/welcome" : "/chat");
    } catch (err) {
      setAlert({ type: "error", msg: err.response?.data?.message || t("error") });
    } finally {
      setLoading(false);
    }
  };
  return <div className="auth-page">
      <div className="auth-bg" />
      <div className="auth-card auth-card--session auth-card--signin">
        <div className="auth-logo-area" onClick={() => navigate("/chat")} style={{ cursor: "pointer" }}>
          <Logo variant="full" size={LOGO_AUTH_DEFAULT} className="auth-logo-img" />
        </div>
        <p className="auth-title">{t("signIn")}</p>
        <SocialAuthButtons onError={setAlert} onLoadingChange={setLoading} />
        <div className="divider">{t("orContinueWith")}</div>
        {alert && <div className={`form-alert ${alert.type}`}>{alert.msg}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">{t("email")}</label>
            <input
    className={`form-input ${errors.email ? "err" : ""}`}
    type="email"
    placeholder="you@example.com"
    value={form.email}
    onChange={(e) => setForm({ ...form, email: e.target.value })}
    autoComplete="email"
  />
            {errors.email && <div className="form-err">⚠ {errors.email}</div>}
          </div>
          <div className="form-group">
            <label className="form-label">{t("password")}</label>
            <div className="input-wrap-pw">
              <input
    className={`form-input with-eye ${errors.password ? "err" : ""}`}
    type={showPw ? "text" : "password"}
    placeholder={t("passwordPlaceholder")}
    value={form.password}
    onChange={(e) => setForm({ ...form, password: e.target.value })}
    autoComplete="current-password"
  />
              <button type="button" className="eye-btn" onClick={() => setShowPw(!showPw)} title={showPw ? t("hidePassword") : t("showPassword")}>
                <EyeIcon open={showPw} />
              </button>
            </div>
            {errors.password && <div className="form-err">⚠ {errors.password}</div>}
            <div style={{ textAlign: "right", marginTop: 4 }}>
              <Link to="/forgot-password" style={{ fontSize: 12, color: "var(--accent)", textDecoration: "none" }}>{t("forgotPassword")}</Link>
            </div>
          </div>
          <button className="btn-primary" type="submit" disabled={loading}>
            {loading ? <><div className="spinner" /> {t("signingIn")}</> : t("signIn")}
          </button>
        </form>
        <div className="auth-foot">{t("noAccount")} <Link to="/signup">{t("createAccount")}</Link></div>
      </div>
    </div>;
};
var stdin_default = SignIn;
export {
  stdin_default as default
};
